export default __webpack_public_path__ + "static/art-7fbe7ec301aa05f1fa06b30b0f13217e.mp4";